export const TURN_ON_NEON = 'TURN_ON_NEON' as const;
export const TURN_OFF_NEON = 'TURN_OFF_NEON' as const;
